var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-dialer-call-card-info", class: _vm.states },
    [
      _c(
        "div",
        {
          staticClass: "icon-button",
          class: ((_obj = {}), (_obj["is-" + _vm.size] = true), _obj),
          attrs: { "data-action": "toggle-members" },
          on: {
            click: function ($event) {
              return _vm.$emit("toggle-members")
            },
          },
        },
        [_c("or-icon", { attrs: { icon: _vm.icon } })],
        1
      ),
      _vm._v(" "),
      _c("app-dialer-call-card-avatars", {
        attrs: {
          avatar: _vm.avatar,
          agent: _vm.agent,
          contact: _vm.contact,
          members: _vm.members,
          size: _vm.size,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "info",
          class: { "is-clickable": _vm.showInfoButton },
          on: {
            mouseenter: function ($event) {
              _vm.isMouseOverInfo = true
            },
            mouseleave: function ($event) {
              _vm.isMouseOverInfo = false
            },
            click: function ($event) {
              _vm.showInfoButton && _vm.$emit("toggle-info")
            },
          },
        },
        [
          _vm.title || _vm.showInfoButton
            ? _c(
                "div",
                { staticClass: "title" },
                [
                  _c("span", { staticClass: "text" }, [
                    _vm._v("\n        " + _vm._s(_vm.title) + "\n      "),
                  ]),
                  _vm._v(" "),
                  _vm.showInfoButton && !_vm.description
                    ? _c("or-icon", {
                        staticClass: "info-button",
                        attrs: { icon: "info", variant: _vm.infoIcon },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.description
            ? _c(
                "div",
                { staticClass: "description" },
                [
                  _c("span", { staticClass: "text" }, [
                    _vm._v("\n        " + _vm._s(_vm.description) + "\n      "),
                  ]),
                  _vm._v(" "),
                  _vm.showInfoButton
                    ? _c("or-icon", {
                        staticClass: "info-button",
                        attrs: { icon: "info", variant: _vm.infoIcon },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }